import {
    ChangeDetectionStrategy,
    Component,
    Injector,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { IChecklist2ReportCheckpoints } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { MatSortDirection, ObjectTypes } from '@fi-shared/types';
import { isEqual } from '@fi-shared/utils';
import { FiInfiniteScrollDataSource } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';

@Component({
    selector: 'fi-checklist-details-checkpoints-table',
    templateUrl: './checklist-details-checkpoints-table.component.html',
    styleUrls: ['./checklist-details-checkpoints-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-details-checkpoints-table' },
    standalone: false,
})
export class FiChecklistDetailsCheckpointsTableComponent
    extends FiInfiniteScrollDataSource<IChecklist2ReportCheckpoints>
    implements OnChanges
{
    @Input() checkpoints: IChecklist2ReportCheckpoints[];
    @Input() searchText: string;
    @Input() isSearchTextHighlighted: boolean;

    private readonly checkpointNameColumnName: string = 'CheckpointName';
    public readonly defaultSortColumnName: string = 'UnitsNotOkCount';
    public readonly itemsListType = FiItemsListType.ChecklistReportDetailsCheckpointsTable;
    public readonly objectType: ObjectTypes = ObjectTypes.Checklist2;

    constructor(injector: Injector) {
        super(injector);
    }

    protected initSelectedSort(): void {
        super.initSelectedSort();

        const haveItemsDeviations: boolean = this.checkpoints.some((item) => {
            return !!item.UnitsNotOkCount;
        });

        if (haveItemsDeviations) {
            this.selectedSort.active = this.defaultSortColumnName;
            this.selectedSort.direction = MatSortDirection.Descending;
        } else {
            this.selectedSort.active = this.checkpointNameColumnName;
            this.selectedSort.direction = MatSortDirection.Ascending;
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        const change = changes.checkpoints;
        if (!!change && !isEqual(change.currentValue, change.previousValue)) {
            this.reloadData();
        }
    }

    protected getCheckpointName(checkpointName: string): string {
        return !this.isSearchTextHighlighted
            ? checkpointName
            : checkpointName.replace(this.searchText, `<span class="BrandedColor">${this.searchText}</span>`);
    }

    public getListData(): Promise<IChecklist2ReportCheckpoints[]> {
        return Promise.resolve(this.checkpoints);
    }
}
